import React, { Fragment, useState, useEffect } from 'react';
import Navbar from '../../Navbar';
import Footer from '../../Footer';
import { useTranslation } from 'react-i18next';
import { Col } from 'react-bootstrap';
import Cookies from 'js-cookie';
import { set } from 'date-fns';
const { config } = require('../../api/api');

function DownloadTermPlanPolicy() {
  const base_url = config.baseURL;
  const redirect_url = config.redirectURL;
  const lnstr = Cookies.get('langData') ? Cookies.get('langData') : 'en';

  const { t } = useTranslation();

  const [vendorKey, setVendorkey] = useState('');
  const [dhofarData, setDhofarData] = useState(null);
  const [downloadpolicy, setDownloadValue] = useState(null);
  const [policyLink, setPolicyLink] = useState(null);
  const [policyBase64, setPolicyBase64] = useState(null);
  const [policy_no, setPolicyNo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [passportFile, setPassportFile] = useState(null);
  const [questionnaireFile, setQuestionnaireFile] = useState(null);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const [fileChoosen, setFileChoosen] = useState(true);
  const [fileupload, setFileupload] = useState('');
  const [isPaid, setIsPaid] = useState(null);

  useEffect(() => {
    const uparams = new URLSearchParams(window.location.search);
    setPolicyNo(uparams.get('policyno'));
  }, []);

  useEffect(() => {
    if (showUploadModal) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
    return () => { document.body.style.overflow = 'auto'; };
  }, [showUploadModal]);

  useEffect(() => {
    if (vendorKey) return;
    const createOrganization = async () => {
      try {
        const response = await fetch(base_url + '/create_organization', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ organization_name: 'Superjet' })
        });
        const data = await response.json();
        setVendorkey(data.result[0].vendor_key);
      } catch (error) {
        console.error('Error creating organization:', error);
      }
    };
    createOrganization();
  }, [vendorKey, base_url]);

  useEffect(() => {
    if (!vendorKey) return;
    const createToken = async () => {
      try {
        const response = await fetch(base_url + '/create_dhofar_tcs_token', {
          method: 'GET',
          headers: { Authorization: `Bearer ${vendorKey}` }
        });
        const data = await response.json();
        setDhofarData(data.result.data.token);
      } catch (error) {
        console.error('Error getting token:', error);
      }
    };
    createToken();
  }, [vendorKey, base_url]);

  useEffect(() => {
    if (!vendorKey || !dhofarData || !policy_no) return;
    fetchPaymentStatus({ token: dhofarData, policy_no });
    fetchPolicyAndLink({ token: dhofarData, policy_no });
  }, [vendorKey, dhofarData, policy_no, base_url]);

  const fetchPaymentStatus = async (payload) => {
    try {
      const res = await fetch(base_url + '/get_dhofar_personal_accident_policy_details', {
        method: 'POST',
        headers: { Authorization: `Bearer ${vendorKey}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await res.json();
      setIsPaid(data.result.data.payments.isPaid);
    } catch (error) {
      console.error('Error fetching payment status:', error);
    }
  };

  const fetchPolicyAndLink = async (payload) => {
    try {
      const res = await fetch(base_url + '/get_term_plan_policy_details', {
        method: 'POST',
        headers: { Authorization: `Bearer ${vendorKey}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data = await res.json();
      setDownloadValue(data.result[0]);
      setFileupload(data.result[0].file_upload);

      const res2 = await fetch(base_url + '/download_personalaccident_policy', {
        method: 'POST',
        headers: { Authorization: `Bearer ${vendorKey}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      });
      const data2 = await res2.json();
      if (data2.message === 'success') {
        const resultData = data2.result.data;
        if (typeof resultData === 'string') {
          setPolicyLink('');
          setPolicyBase64(resultData);
        } else {
          setPolicyLink(resultData?.policy_schedule_url || '');
          setPolicyBase64(null);
        }
      } else {
        setPolicyLink('');
        setPolicyBase64(null);
      }
    } catch (error) {
      console.error('Error fetching policy and link:', error);
      setPolicyLink('');
      setPolicyBase64(null);
    }
  };

  const handleQotation = async () => {
    if (!vendorKey) return;
    try {
      setLoading(true);
      const quotation_data = {
        token: dhofarData,
        policy_no,
        redirect_url: redirect_url + '/termplan-downloadpolicy?policyno=' + policy_no
      };
      const response = await fetch(base_url + '/create_term_plan_payment_link', {
        method: 'POST',
        headers: { Authorization: `Bearer ${vendorKey}`, 'Content-Type': 'application/json' },
        body: JSON.stringify(quotation_data)
      });
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      window.location.href = data.result.data.payment_url;
    } catch (error) {
      console.error('Error creating payment link:', error);
    }
  };

  const handleSubmit = () => {
    window.location.href = '/insurance';
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append('token', dhofarData);
    formData.append('policy_number', policy_no);
    if (passportFile) formData.append('passport', passportFile);
    if (downloadpolicy.policy_data?.is_armed_member !== 'No' && questionnaireFile) {
      formData.append('questionnaire', questionnaireFile);
    }

    setLoading(true);
    try {
      const endpoint = downloadpolicy.policy_data?.is_armed_member === 'No'
        ? '/term_plan_file_upload_armed'
        : '/term_plan_file_upload';

      const response = await fetch(base_url + endpoint, {
        method: 'POST',
        headers: { Authorization: `Bearer ${vendorKey}` },
        body: formData
      });
      const data = await response.json();
      if (data.result.success) {
        alert(data.result.message);
        setPassportFile(null);
        setQuestionnaireFile(null);
        handleClose();
        await fetchPolicyAndLink({ token: dhofarData, policy_no });
      } else {
        alert('File upload failed, please try again.');
      }
    } catch (error) {
      console.error('Upload error:', error);
      alert('File upload failed, please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleFileChange = (e) => {
    if (e.target.files.length !== 1) return;
    const file = e.target.files[0];
    const name = e.target.name;
    const fileType = file.type;
    const maxSize = 2 * 1024 * 1024;

    if (file.size > maxSize) {
      alert('File size exceeds the 2MB limit.');
      document.getElementById(name).value = '';
      return;
    }

    const isValidType = fileType === 'application/pdf' || (name === 'questionnaire' && (fileType.startsWith('image/') || fileType === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document')) ;
    if (isValidType) {
      if (name === 'passport') setPassportFile(file);
      else if (name === 'questionnaire') setQuestionnaireFile(file);
    } else {
      alert('Please select a valid PDF file.');
    }
    document.getElementById(name).value = '';
  };

  const handleFileDelete = (e) => {
    const name = e.target.getAttribute('data-name');
    if (name === 'questionnaire') {
      setQuestionnaireFile(null);
      document.getElementById('questionnaire').value = '';
    } else if (name === 'passport') {
      setPassportFile(null);
      document.getElementById('passport').value = '';
    }
  };

  const handleClose = () => setShowUploadModal(false);
  const handleShow = () => setShowUploadModal(true);

  useEffect(() => {
    if (downloadpolicy?.policy_data?.is_armed_member === 'Yes') {
      setFileChoosen(!(passportFile && questionnaireFile));
    } else {
      setFileChoosen(!passportFile);
    }
  }, [passportFile, questionnaireFile, downloadpolicy]);

  return (
    <Fragment>
      <div className="header_section1">
        <Navbar />
        <div className="container-fluid bg-breadcrumb">
          <div className="container text-center py-5">
            <h3 className="abt-txt my-5">
              {lnstr === 'en' ? 'Download Policy - ' + policy_no : 'تحميل السياسة'}
            </h3>
          </div>
        </div>
      </div>

      <div className="features_section">
        <div className="container">
          <div className="row">
            <Col md={2}></Col>
            <Col md={8} className="myforms my-5" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
              <br />
              <table className="table table-bordered table-condenced" style={{ textAlign: 'left' }}>
                <tbody>
                  <tr>
                    <td style={{ width: '50%' }}><b>{t("Name")}</b></td>
                    <td>{downloadpolicy?.first_name || ''}</td>
                  </tr>
                  <tr>
                    <td><b>{t("Email")}</b></td>
                    <td>{downloadpolicy?.email || ''}</td>
                  </tr>
                  <tr>
                    <td><b>{t("Passport")}</b></td>
                    <td>{downloadpolicy?.passport || ''}</td>
                  </tr>
                  <tr>
                    <td><b>{t("Cover")} {t("Type")}</b></td>
                    <td>{downloadpolicy?.policy_data?.cover_type || ''}</td>
                  </tr>
                  <tr>
                    <td><b>{t("Civil ID")}</b></td>
                    <td>{downloadpolicy?.policy_data?.civil_id || ''}</td>
                  </tr>
                  <tr>
                    <td><b>{t("Policy No")}</b></td>
                    <td>{policy_no || ''}</td>
                  </tr>
                </tbody>
              </table>

              <div className="col-12 d-flex flex-column align-items-center">
                {isPaid && fileupload !== 'yes' && (
                  <div className="row w-100 justify-content-center">
                    <div className="col-lg-4 col-md-4 col-sm-8 col-8 p-1 mb-2 d-flex justify-content-center" style={{ width: '33%' }}>
                      <button type="button" className="btn btn-primary w-100" onClick={handleShow}>
                        {t("Upload")} {t("Documents")}
                      </button>
                    </div>
                  </div>
                )}

                {(policyLink != null && policyLink !== '') || policyBase64 ? (
                  fileupload === 'yes' ? (
                    <div className="row w-100 justify-content-between">
                      <div className="col-lg-4 col-md-4 col-sm-8 col-8 p-1 mb-2 d-flex justify-content-center" style={{ width: '33%' }}>
                        <button
                          className="btn btn-primary w-100"
                          onClick={() => {
                            if (policyLink) {
                              const link = document.createElement('a');
                              link.href = policyLink;
                              link.target = '_blank';
                              link.download = policyLink.split('/').pop();
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                            } else if (policyBase64) {
                              const byteChars = atob(policyBase64);
                              const byteArr = new Uint8Array([...byteChars].map(c => c.charCodeAt(0)));
                              const blob = new Blob([byteArr], { type: 'application/pdf' });
                              const url = URL.createObjectURL(blob);
                              const link = document.createElement('a');
                              link.href = url;
                              link.download = `policy_${policy_no}.pdf`;
                              document.body.appendChild(link);
                              link.click();
                              document.body.removeChild(link);
                              URL.revokeObjectURL(url);
                            }
                          }}
                        >
                          {t("Download")} {t("Policy")}
                        </button>
                      </div>
                      <div className="col-lg-4 col-md-4 col-sm-8 col-8 p-1 mb-2 d-flex justify-content-center" style={{ width: '33%' }}>
                        <button className="btn btn-primary w-100" onClick={handleSubmit}>
                          {t("Go To Home")}
                        </button>
                      </div>
                    </div>
                  ) : ''
                ) : isPaid === false || (isPaid !== null && !isPaid) ? (
                  <div className="text-center">
                    <h2>{t("Policy")} {t("Payment")} {t("Pending")}</h2>
                    <div>
                      <button
                        onClick={handleQotation}
                        style={{ marginLeft: 'auto', fontWeight: 'bold', backgroundColor: '#3fd2f2', color: 'white' }}
                      >
                        {t("Make Payment")}
                      </button>
                    </div>
                  </div>
                ) : ''}
              </div>
            </Col>
            <Col md={2}></Col>
          </div>
        </div>
      </div>

      <Footer />

      {showUploadModal && (
        <div className="modal fade show" style={{ display: 'block' }} id="uploadModal">
          <div className="modal-dialog modal-dialog-centered modal-lg" style={{ left: '10%' }}>
            <div className="modal-content">
              <div className="modal-header">
                <h2 className="modal-title">
                  <span>{t('Upload')} {t('Documents')}</span>
                  <p style={{ color: 'red', marginLeft: '25px' }}>
                    {lnstr === 'en' ? 'Please upload a PDF file only.' : 'الرجاء تحميل ملف PDF فقط.'}
                  </p>
                </h2>
                <button type="button" className="close" onClick={handleClose}>&times;</button>
              </div>
              <div className="modal-body">
                <form onSubmit={handleUpload}>
                  <div className="form-group row">
                    <label className="col-sm-12 col-md-8 col-form-label text-left">
                      <strong>{t('Passport copy With visa page or Resident ID')}</strong>
                    </label>
                    <div className="col-sm-12 col-md-4">
                      {passportFile === null ? (
                        <button className="btn btn-primary" type="button" onClick={() => document.getElementById('passport').click()}>
                          {t('Upload')} {t('File')}
                        </button>
                      ) : (
                        <div className="d-flex border mt-2 align-items-center p-2 rounded">
                          <p className="mb-0" style={{ width: '80%' }}>
                            {passportFile.name.length > 5
                              ? `${passportFile.name.substring(0, 5)}...${passportFile.type.split('/')[1]}`
                              : passportFile.name}
                          </p>
                          <span
                            className="text-danger ms-auto"
                            onClick={handleFileDelete}
                            data-name="passport"
                            style={{ cursor: 'pointer', width: '20%' }}
                          >
                            &times;
                          </span>
                        </div>
                      )}
                    </div>
                  </div>

                  {downloadpolicy?.policy_data?.is_armed_member === 'Yes' && (
                    <div className="form-group row mt-3">
                      <label className="col-sm-12 col-md-8 col-form-label text-left">
                        <strong>{t('Filled questionnaire')}</strong>
                      </label>
                      <div className="col-sm-12 col-md-4">
                        {questionnaireFile === null ? (
                          <button className="btn btn-primary" type="button" onClick={() => document.getElementById('questionnaire').click()}>
                            {t('Upload')} {t('File')}
                          </button>
                        ) : (
                          <div className="d-flex border mt-2 align-items-center p-2 rounded">
                            <p className="mb-0" style={{ width: '80%' }}>
                              {questionnaireFile.name.length > 10
                                ? `${questionnaireFile.name.substring(0, 5)}...${questionnaireFile.name.split('.').pop()}`
                                : questionnaireFile.name}
                            </p>
                            <span
                              className="text-danger ms-auto"
                              onClick={handleFileDelete}
                              data-name="questionnaire"
                              style={{ cursor: 'pointer', width: '20%' }}
                            >
                              &times;
                            </span>
                          </div>
                        )}
                      </div>
                    </div>
                  )}

                  <input
                    type="file"
                    name="passport"
                    id="passport"
                    accept="application/pdf"
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                  />
                  <input
                    type="file"
                    name="questionnaire"
                    id="questionnaire"
                     accept="application/pdf,image/*,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    style={{ display: 'none' }}
                    onChange={handleFileChange}
                  />

                  <div className="mt-4 text-center">
                    <button type="submit" disabled={fileChoosen} className="btn btn-primary">
                      {t('Submit')}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      )}

      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
    </Fragment>
  );
}

export default DownloadTermPlanPolicy;
